import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import SEALogo from '../../assets/SEA-round.png';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@emotion/react';

// const pages = ['Products', 'Pricing', 'Blog'];
// const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function Header() {
  // const [anchorElNav, setAnchorElNav] = React.useState(null);
  // const [anchorElUser, setAnchorElUser] = React.useState(null);

  // const handleOpenNavMenu = (event) => {
  //   setAnchorElNav(event.currentTarget);
  // };
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  // const handleCloseNavMenu = () => {
  //   setAnchorElNav(null);
  // };

  // const handleCloseUserMenu = () => {
  //   setAnchorElUser(null);
  // };

  const customTheme = createTheme({
    root: {
      display: "flex",
    },
    palette: {
      primary: {
        main: "#FFF",
      },
    }
  });

  return (
    <ThemeProvider theme={customTheme}>
    <AppBar position="fixed" className='header'>
      <Container sx={{ maxWidth:'1240px' }} maxWidth={false} className='content' >
        <Box className='logo-group'>
          <Link href="https://www.sea.com/home">
          <Box component="img" alt="SEA logo" src={SEALogo} sx={{ height:50 }} />
          </Link>
          {/* <img src={SEALogo} style={{ height:70 }} /> */}
        </Box>
      </Container>
    </AppBar>
    </ThemeProvider>
  );
}
export default Header;
